import { privateApi } from 'services';
import { Journey } from './types';

const fetchJourneys = async (businessAccountId: string): Promise<Journey[]> =>
    privateApi.get(`business-accounts/${businessAccountId}/leads/journeys`);

export const JourneysGateway = {
    fetchJourneys,
};
